import React, { Component, Suspense, lazy } from 'react'
import {
  Route,
  Switch,
  Redirect,
  Link,
  NavLink
} from 'react-router-dom'
import { AppWrapper } from '~/styles'
import compose from 'lodash/flowRight'
import { useQuery } from '@apollo/react-hooks'
import { withApollo, graphql } from 'react-apollo'
import { withTranslation } from 'react-i18next'
// import Dashboard from './components/Dashboard'
import Events from './components/Events'
const Organizers = lazy(() => import('./components/Organizers/Organizers'))
const Admins = lazy(() => import('./components/Admins/Admins'))
const EventForms = lazy(() => import('./components/EventForms'))
const EventSummaryPayment = lazy(() => import('./components/EventSummaryPayment'))
const FinancialDailyBalance = lazy(() => import('./components/FinancialDailyBalance'))
const FetchPage = lazy(() => import('./components/FetchPage'))
const Reports = lazy(() => import('./components/Reports'))
const StatisticsVR = lazy(() => import('./components/StatisticsVR/StatisticsVR'))
const MedalClaims = lazy(() => import('./components/MedalClaims'))
import adminQuery from '~/graphql/queries/adminUser.gql'
const UserTranfer = lazy(() => import('./components/Users/Tranfer/UserTranfer'))
// const Withdraw = lazy(() => import('./components/Withdraw/'))
// import Registrations from '~/components/Events/Event/Registrations'
// import EventEdit from './components/EventEdit'
// import EventParticipants from './components/EventParticipants'
// import Participant from './components/Participant'
// import EventRegistrations from './components/EventRegistrations'
// import EventPayments from './components/EventPayments'
// import Registration from './components/Registration'
// import Payment from './components/Payment'
// import EventTickets from './components/EventTickets'
// import Ticket from './components/Ticket'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import styled from 'styled-components'
// import { Layout, Menu, /* Breadcrumb, */ Dropdown, Icon, Button } from 'antd'
import { Popover, Button, Icon, Menu as AntMenu, Select } from 'antd'
import clientAuth from './utils/client-auth'
import {
  ProSidebar, Menu, MenuItem,
  SidebarHeader, SidebarFooter, SidebarContent
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
// const { SubMenu } = Menu
// const { Header, Content, Sider } = Layout

// import '~/styles/App.css'
import '~/styles/global.css'
import { MainMenu } from './styles/mainmenu'
import config from './config'
const UserList = lazy(() => import('./components/Users/List/UserList'))
const { SubMenu } = AntMenu
const Campaigns = lazy(() => import('./components/Campaigns'))
const Histories = lazy(() => import('./components/Histories'))
// const CampaignEdit = lazy(() => import('./components/Campaigns/Edit'))
const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$')

const StyledSelect = styled(Select)`
.ant-select-selection {
  // border: 2px solid #1D81C4 !important;
  border: none;
  border-radius: 20px;
  box-shadow: none !important;
  background: none;
  color: #1D81C4;
  .ant-select-selection__rendered {
    margin-right: 11px;
  }
}
.ant-select-arrow {
  display: none;
  color: #1D81C4;
}
`

const locales = {
  en: ' 🇺🇸',
  th: ' 🇹🇭',
}

@graphql(adminQuery, {
  options: (props) => ({
    variables: {
      _id: clientAuth.login()._id
    }
  }),
  props: ({ data: { loading, adminUser } }) => ({
    adminLoading: loading,
    admin: adminUser
  })
})
class App extends Component {
  state = {
    toggled: false
  }
  handleMenuClick = ({ item, key, keyPath }) => {
    if (key === 'logout') {
      clientAuth.logout()
      this.props.client.resetStore()
      this.props.history.push('/login')
    }
  }
  handleBreadcrumb = ({ pathname }) => {
    if (!pathname) return ''

    let breadcrumbLabel = ''
    pathname.split('/').forEach((s, i) => {
      if (i > 0) {
        if (s[0]) breadcrumbLabel = `${breadcrumbLabel} / ${s[0].toUpperCase()}${s.slice(1)}`
      }
    })
    return breadcrumbLabel
  }
  handleToggleSidebar = (value) => {
    this.setState({ toggled: value })
  }
  handleToggleClose = () => {
    this.setState({ toggled: false })
  }
  render() {
    const roles = _get(this.props, 'roles', [])
    const { t } = this.props
    const handleLanguageChange = (locale) => {
      this.props.i18n.changeLanguage(locale)
    }
    const adminLoading = _get(this.props, 'adminLoading')
    if (adminLoading) return ''
    const admin = _get(this.props, 'admin')
    if (!(_includes(roles, 'admin') || _includes(roles, 'organizer') || _includes(roles, 'accountant'))) {
      return <div type="primary" style={{ textAlign: 'center' }}>
        <h1>Invalid roles please contact super admin</h1>
        <Button onClick={() => this.handleMenuClick({ key: 'logout' })}>
          <img style={{ width: '50px' }} src={config.logo} alt="ThaiRun" />
          [{this.props.email}] ออกจากระบบ
        </Button>
      </div>
    }
    let eventId = null
    const pathname = this.props.location.pathname.split('/')
    if (_get(pathname, [1]) === 'events') {
      if (_get(pathname, [2])) {
        eventId = _get(pathname, [2])
      }
    }
    if (!_includes(roles, 'admin') && _includes(roles, 'organizer')) { // validation events permission
      // eventId = _get(pathname, 'length') > 2 ? pathname[2] : null
      const eventIds = _get(this.props, 'admin.eventIds')
      if (eventId && !eventIds.includes(eventId) && checkForHexRegExp.test(eventId)) {
        this.props.history.push(`/events`)
      }
    }

    const menuItems = [
      <AntMenu.Item key="events">
        <Link to="/events">
          งานวิ่ง
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') &&
      <AntMenu.Item key="createEvent">
        <Link to="/fetchPage?link=/events/create">
          สร้างงานวิ่ง
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="organizers">
        <Link to="/organizers">
          ผู้จัดงาน
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="admins">
        <Link to="/admins">
          ผู้ดูแลระบบ
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="eventForms">
        <Link to="/eventForms">
          ติดต่อเปิดงานวิ่ง
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="eventSummaryPayment">
        <Link to="/eventSummaryPayment">
          สรุปการเงิน
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="StatisticsVR">
        <Link to="/StatisticsVR">
          Statistics VR
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="MedalClaims">
        <Link to="/MedalClaims">
          รับเหรียญ
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="campaigns">
        <Link to="/campaigns">
          Campaigns
        </Link>
      </AntMenu.Item>,
      _includes(roles, 'admin') && <AntMenu.Item key="histories">
        <Link to="/histories">
          History
        </Link>
      </AntMenu.Item>

    ]
    const menu = (
      <AntMenu onClick={this.handleMenuClick} >
        {menuItems}
        <AntMenu.Item key="logout" style={{ borderTop: '1px solid rgba(0, 0, 0, 0.13)' }}>
          ออกจากระบบ
        </AntMenu.Item>
      </AntMenu>
    )
    const activedPathname = _get(pathname, [1])
    const activedPathname2 = _get(pathname, [2])
    const CheckIsActivePath = ({ paths }) => {
      let isActive = paths.includes(activedPathname)
      if (activedPathname === 'events' && activedPathname2 === 'create' && paths[0] === 'events/create') {
        isActive = true
      } else if (activedPathname === 'events' && activedPathname2 === 'create' && paths[0] === 'events') {
        isActive = false
      }
      // console.log('activedPathname', activedPathname, paths, activedPathname2)
      return {
        isActive: isActive ? `active` : ``,
        activeSvgProps: (
          isActive ?
            { fill: "#F9A01B" } :
            { "fill": "white", "fillOpacity": "1" }
          // {"fill":"black", "fillOpacity":"0.34"}
        ),
        activeMobileSvgProps: (
          isActive ?
            { fill: "white" } :
            { "fill": "white", "fillOpacity": "1" }
        )
      }
    }
    const screenHeight = window.innerHeight
    const isLineLogin = false
    const isUnsetQb = false
    const defaultOpenKeys = [_get(pathname, [1])]
    const selectedKeys = [_get(pathname, [3])]
    return (
      <AppWrapper>
        <div className={_includes(roles, 'admin') ? 'layout-content' : ' layout-content noCreateEvent'}>
          <MainMenu screenHeight={screenHeight}>
            <div className="desktop">
              <ProSidebar
                collapsed={true}
              // toggled={this.state.toggled}
              // breakPoint="md"
              // onToggle={handleToggleSidebar}
              >
                <SidebarHeader>
                  <div className="logo">
                    <Link to="/">
                      <img src={config.logo} alt="ThaiRun" />
                    </Link>
                  </div>
                </SidebarHeader>
                <SidebarContent>
                  <Menu iconShape="square">
                    <MenuItem
                      className={CheckIsActivePath({ paths: ['events'] }).isActive}
                      icon={
                        <div>
                          {/* <i className="fas fa-running mainiconmenu"></i> */}
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.55 3.25C16.55 4.35 15.65 5.25 14.55 5.25C13.45 5.25 12.55 4.35 12.55 3.25C12.55 2.15 13.45 1.25 14.55 1.25C15.65 1.25 16.55 2.15 16.55 3.25ZM11.95 14.75L10.95 19.15L3.95001 17.75L4.35001 15.75L9.25001 16.75L10.85 8.65L9.05001 9.35V12.75H7.05001V8.05L12.25 5.85C12.4 5.85 12.525 5.825 12.65 5.8C12.775 5.775 12.9 5.75 13.05 5.75C13.75 5.75 14.35 6.15 14.75 6.75L15.75 8.35C16.55 9.75 18.15 10.75 20.05 10.75V12.75C17.85 12.75 15.85 11.75 14.55 10.25L13.95 13.25L16.05 15.25V22.75H14.05V16.75L11.95 14.75Z"
                              {...CheckIsActivePath({ paths: ['events'] }).activeSvgProps}
                            />
                          </svg>
                          <span className="menu-title">Races</span>
                        </div>
                      }
                    >
                      <Link to="/" />
                    </MenuItem>
                  </Menu>
                  {
                    // _includes(roles, 'admin') && <Menu iconShape="square">
                    //   <MenuItem
                    //   className={CheckIsActivePath({paths: ['campaigns']}).isActive}
                    //     icon={
                    //       <div>
                    //         {/* <i className="fas fa-chalkboard mainiconmenu"></i> */}
                    //         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //           <path fill-rule="evenodd" clip-rule="evenodd" d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM8 15H6V13H4V11H6V9H8V11H10V13H8V15ZM14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12ZM17 10.5C17 9.67157 17.6716 9 18.5 9C19.3284 9 20 9.67157 20 10.5C20 11.3284 19.3284 12 18.5 12C17.6716 12 17 11.3284 17 10.5Z"
                    //             {...CheckIsActivePath({paths: ['campaigns']}).activeSvgProps}
                    //           />
                    //         </svg>
                    //         <span className="menu-title">Campaign</span>
                    //       </div>
                    //     }
                    //   >
                    //     <Link to="/campaigns" />
                    //   </MenuItem>
                    // </Menu>
                  }
                  {config.hiddenField &&
                    <>
                      {_includes(roles, 'admin') && <Menu iconShape="square">
                        <MenuItem
                          className={CheckIsActivePath({ paths: ['eventSummaryPayment'] }).isActive}
                          icon={
                            <div>
                              {/* <i className="fas fa-comment-alt mainiconmenu"></i> */}
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http:www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM8 15H6V13H4V11H6V9H8V11H10V13H8V15ZM14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12ZM17 10.5C17 9.67157 17.6716 9 18.5 9C19.3284 9 20 9.67157 20 10.5C20 11.3284 19.3284 12 18.5 12C17.6716 12 17 11.3284 17 10.5Z"
                                  {...CheckIsActivePath({ paths: ['campaigns'] }).activeSvgProps}
                                />
                              </svg>
                              <span className="menu-title">Summary</span>
                            </div>
                          }
                        >
                          <Link to="/eventSummaryPayment" />
                        </MenuItem>
                      </Menu>}
                      {_includes(roles, 'admin') && <Menu iconShape="square">
                        <MenuItem
                          className={CheckIsActivePath({ paths: ['financialDailyBalance'] }).isActive}
                          icon={
                            <div>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3 5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5ZM5 5V19H19V5H5ZM7 17H9V10H7V17ZM11 17H13V7H11V17ZM15 17H17V13H15V17Z"
                                  {...CheckIsActivePath({ paths: ['financialDailyBalance'] }).activeSvgProps}
                                />
                              </svg>
                              <span className="menu-title">Balance</span>
                            </div>
                          }
                        >
                          <Link to="/financialDailyBalance" />
                        </MenuItem>
                      </Menu>}
                      {_includes(roles, 'admin') && <Menu iconShape="square">
                        <MenuItem
                          className={CheckIsActivePath({ paths: ['eventForms'] }).isActive}
                          icon={
                            <div>
                              {/* <i className="fas fa-comment-alt mainiconmenu"></i> */}
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM6 16H20V4H4V18L6 16Z"
                                  {...CheckIsActivePath({ paths: ['eventForms'] }).activeSvgProps}
                                />
                              </svg>
                              <span className="menu-title">Request</span>
                            </div>
                          }
                        >
                          <Link to="/eventForms" />
                        </MenuItem>
                      </Menu>}
                    </>
                  }
                  {
                    // _includes(roles, 'admin') && <Menu iconShape="square">
                    //   <MenuItem
                    //   className={CheckIsActivePath({paths: ['StatisticsVR']}).isActive}
                    //     icon={
                    //       <div>
                    //         {/* <i className="fas fa-running mainiconmenu"></i> */}
                    //         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //           <path fill-rule="evenodd" clip-rule="evenodd" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM9 10H7V17H9V10ZM11 7H13V17H11V7ZM17 13H15V17H17V13Z"
                    //             {...CheckIsActivePath({paths: ['StatisticsVR']}).activeSvgProps}
                    //           />
                    //         </svg>
                    //         <span className="menu-title">Report</span>
                    //       </div>
                    //     }
                    //   >
                    //     <Link to="/StatisticsVR" />
                    //   </MenuItem>
                    // </Menu>
                  }
                  {_includes(roles, 'admin') && <Menu iconShape="square">
                    <MenuItem
                      className={CheckIsActivePath({ paths: ['reports'] }).isActive}
                      icon={
                        <div>
                          {/* <i className="fas fa-running mainiconmenu"></i> */}
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM9 10H7V17H9V10ZM11 7H13V17H11V7ZM17 13H15V17H17V13Z"
                              {...CheckIsActivePath({ paths: ['reports'] }).activeSvgProps}
                            />
                          </svg>
                          <span className="menu-title">Report</span>
                        </div>
                      }
                    >
                      <Link to="/reports" />
                    </MenuItem>
                  </Menu>}
                  {_includes(roles, 'admin') && <Menu iconShape="square">
                    <MenuItem
                      className={CheckIsActivePath({ paths: ['users', 'organizers', 'admins'] }).isActive}
                      icon={
                        <div>
                          {/* <i className="fas fa-running mainiconmenu"></i> */}
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8ZM18 18C17.8 17.29 14.7 16 12 16C9.31 16 6.23 17.28 6 18H18ZM4 18C4 15.34 9.33 14 12 14C14.67 14 20 15.34 20 18V20H4V18Z"
                              {...CheckIsActivePath({ paths: ['users', 'organizers', 'admins'] }).activeSvgProps}
                            />
                          </svg>

                          <span className="menu-title">Users</span>
                        </div>
                      }
                    >
                      <Link to="/users/organizers" />
                    </MenuItem>
                  </Menu>}
                  {_includes(roles, 'admin') && <Menu iconShape="square">
                    <MenuItem
                      className={CheckIsActivePath({ paths: ['events/create'] }).isActive}
                      icon={
                        <div>
                          {/* <i className="fas fa-running mainiconmenu"></i> */}
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                              {...CheckIsActivePath({ paths: ['events/create'] }).activeSvgProps}
                            />
                          </svg>

                          <span className="menu-title">Create race</span>
                        </div>
                      }
                    >
                      <Link to="/events/create" />
                    </MenuItem>

                  </Menu>}
                  {/* {(_includes(roles, 'admin') || _includes(roles, 'accountant')) && <Menu iconShape="square">
                    <MenuItem
                    className={CheckIsActivePath({paths: ['withdraw']}).isActive}
                      icon={
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                            <path d="M33 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V16.5C1.5 16.8978 1.65804 17.2794 1.93934 17.5607C2.22064 17.842 2.60218 18 3 18H7.5V31.5C7.5 31.8978 7.65804 32.2794 7.93934 32.5607C8.22064 32.842 8.60218 33 9 33H27C27.3978 33 27.7794 32.842 28.0607 32.5607C28.342 32.2794 28.5 31.8978 28.5 31.5V18H33C33.3978 18 33.7794 17.842 34.0607 17.5607C34.342 17.2794 34.5 16.8978 34.5 16.5V4.5C34.5 4.10218 34.342 3.72064 34.0607 3.43934C33.7794 3.15804 33.3978 3 33 3ZM10.5 30V27C11.2956 27 12.0587 27.3161 12.6213 27.8787C13.1839 28.4413 13.5 29.2044 13.5 30H10.5ZM25.5 30H22.5C22.5 29.2044 22.8161 28.4413 23.3787 27.8787C23.9413 27.3161 24.7044 27 25.5 27V30ZM25.5 24C23.9087 24 22.3826 24.6321 21.2574 25.7574C20.1321 26.8826 19.5 28.4087 19.5 30H16.5C16.5 28.4087 15.8679 26.8826 14.7426 25.7574C13.6174 24.6321 12.0913 24 10.5 24V12H25.5V24ZM31.5 15H28.5V10.5C28.5 10.1022 28.342 9.72064 28.0607 9.43934C27.7794 9.15804 27.3978 9 27 9H9C8.60218 9 8.22064 9.15804 7.93934 9.43934C7.65804 9.72064 7.5 10.1022 7.5 10.5V15H4.5V6H31.5V15ZM18 22.5C18.89 22.5 19.76 22.2361 20.5001 21.7416C21.2401 21.2471 21.8169 20.5443 22.1575 19.7221C22.4981 18.8998 22.5872 17.995 22.4135 17.1221C22.2399 16.2492 21.8113 15.4474 21.182 14.818C20.5526 14.1887 19.7508 13.7601 18.8779 13.5865C18.005 13.4128 17.1002 13.5019 16.2779 13.8425C15.4557 14.1831 14.7529 14.7599 14.2584 15.4999C13.7639 16.24 13.5 17.11 13.5 18C13.5 19.1935 13.9741 20.3381 14.818 21.182C15.6619 22.0259 16.8065 22.5 18 22.5ZM18 16.5C18.2967 16.5 18.5867 16.588 18.8334 16.7528C19.08 16.9176 19.2723 17.1519 19.3858 17.426C19.4994 17.7001 19.5291 18.0017 19.4712 18.2926C19.4133 18.5836 19.2704 18.8509 19.0607 19.0607C18.8509 19.2704 18.5836 19.4133 18.2926 19.4712C18.0017 19.5291 17.7001 19.4994 17.426 19.3858C17.1519 19.2723 16.9176 19.08 16.7528 18.8334C16.588 18.5867 16.5 18.2967 16.5 18C16.5 17.6022 16.658 17.2206 16.9393 16.9393C17.2206 16.658 17.6022 16.5 18 16.5Z"
                             {...CheckIsActivePath({paths: ['withdraw']}).activeSvgProps}
                            />
                          </svg>

                          <span className="menu-title">Withdraw</span>
                        </div>
                      }
                    >
                      <Link to="/withdraw" />
                    </MenuItem>                    
                  </Menu>} */}
                  {config.hiddenField &&
                    <>
                      {_includes(roles, 'admin') && <Menu iconShape="square">
                        <MenuItem
                          className={CheckIsActivePath({ paths: ['histories'] }).isActive}
                          icon={
                            <div>
                              {/* <i className="fas fa-running mainiconmenu"></i> */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path fill="#FFFFFF" d="M18.5,12c0,4.142-3.358,7.5-7.5,7.5S3.5,16.142,3.5,12S6.858,4.5,11,4.5S18.5,7.858,18.5,12z M11,6h-1v6l4.5,2.67 l0.75-1.23l-3.75-2.22V6z"
                                  {...CheckIsActivePath({ paths: ['histories'] }).activeSvgProps}
                                />
                              </svg>

                              <span className="menu-title">History</span>
                            </div>
                          }
                        >
                          <Link to="/histories" />
                        </MenuItem>
                      </Menu>}
                    </>
                  }
                </SidebarContent>
                <Menu>
                  <MenuItem>
                    <StyledSelect
                      style={{
                        width: 90
                      }}
                      defaultValue={this.props.i18n.language === 'en-US' || this.props.i18n.language === 'en' ? locales.en : locales.th}
                      onChange={(locale) => handleLanguageChange(locale)}
                    >
                      {Object.entries(locales).map(([key, label], i) => (
                        <Option key={key} value={key}>
                          {label}
                        </Option>
                      ))}
                    </StyledSelect>
                  </MenuItem>
                </Menu>
                <SidebarFooter>
                  <Menu iconShape="square">
                    <MenuItem
                      icon={
                        <div>
                          <Popover placement="rightBottom" content={
                            <div>
                              <Button onClick={() => this.handleMenuClick({ key: 'logout' })}>
                                [{this.props.email}] ออกจากระบบ
                              </Button>
                            </div>
                          } trigger="click">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                              <path d="M19.5023 12C19.5023 12.34 19.4723 12.66 19.4323 12.98L21.5423 14.63C21.7323 14.78 21.7823 15.05 21.6623 15.27L19.6623 18.73C19.5723 18.89 19.4023 18.98 19.2323 18.98C19.1723 18.98 19.1123 18.97 19.0523 18.95L16.5623 17.95C16.0423 18.34 15.4823 18.68 14.8723 18.93L14.4923 21.58C14.4623 21.82 14.2523 22 14.0023 22H10.0023C9.75228 22 9.54228 21.82 9.51228 21.58L9.13228 18.93C8.52228 18.68 7.96228 18.35 7.44228 17.95L4.95228 18.95C4.90228 18.97 4.84228 18.98 4.78228 18.98C4.60228 18.98 4.43228 18.89 4.34228 18.73L2.34228 15.27C2.22228 15.05 2.27228 14.78 2.46228 14.63L4.57228 12.98C4.53228 12.66 4.50228 12.33 4.50228 12C4.50228 11.67 4.53228 11.34 4.57228 11.02L2.46228 9.37C2.27228 9.22 2.21228 8.95 2.34228 8.73L4.34228 5.27C4.43228 5.11 4.60228 5.02 4.77228 5.02C4.83228 5.02 4.89228 5.03 4.95228 5.05L7.44228 6.05C7.96228 5.66 8.52228 5.32 9.13228 5.07L9.51228 2.42C9.54228 2.18 9.75228 2 10.0023 2H14.0023C14.2523 2 14.4623 2.18 14.4923 2.42L14.8723 5.07C15.4823 5.32 16.0423 5.65 16.5623 6.05L19.0523 5.05C19.1023 5.03 19.1623 5.02 19.2223 5.02C19.4023 5.02 19.5723 5.11 19.6623 5.27L21.6623 8.73C21.7823 8.95 21.7323 9.22 21.5423 9.37L19.4323 11.02C19.4723 11.34 19.5023 11.66 19.5023 12ZM17.5023 12C17.5023 11.79 17.4923 11.58 17.4523 11.27L17.3123 10.14L18.2023 9.44L19.2723 8.59L18.5723 7.38L17.3023 7.89L16.2423 8.32L15.3323 7.62C14.9323 7.32 14.5323 7.09 14.1023 6.91L13.0423 6.48L12.8823 5.35L12.6923 4H11.3023L11.1023 5.35L10.9423 6.48L9.88228 6.91C9.47228 7.08 9.06228 7.32 8.63228 7.64L7.73228 8.32L6.69228 7.9L5.42228 7.39L4.72228 8.6L5.80228 9.44L6.69228 10.14L6.55228 11.27C6.52228 11.57 6.50228 11.8 6.50228 12C6.50228 12.2 6.52228 12.43 6.55228 12.74L6.69228 13.87L5.80228 14.57L4.72228 15.41L5.42228 16.62L6.69228 16.11L7.75228 15.68L8.66228 16.38C9.06228 16.68 9.46228 16.91 9.89228 17.09L10.9523 17.52L11.1123 18.65L11.3023 20H12.7023L12.9023 18.65L13.0623 17.52L14.1223 17.09C14.5323 16.92 14.9423 16.68 15.3723 16.36L16.2723 15.68L17.3123 16.1L18.5823 16.61L19.2823 15.4L18.2023 14.56L17.3123 13.86L17.4523 12.73C17.4823 12.43 17.5023 12.21 17.5023 12ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM10.0023 12C10.0023 13.1 10.9023 14 12.0023 14C13.1023 14 14.0023 13.1 14.0023 12C14.0023 10.9 13.1023 10 12.0023 10C10.9023 10 10.0023 10.9 10.0023 12Z" fill="white" fillOpacity="1" />
                            </svg> */}
                            <div>
                              <Icon type="logout" />
                            </div>
                            <div style={{ marginTop: '7px' }}>
                              <span className="menu-title">Logout</span>
                            </div>
                          </Popover>
                        </div>
                      }
                    >
                    </MenuItem>
                  </Menu>
                </SidebarFooter>
              </ProSidebar>
            </div>
            <div className="mobile">
              <ProSidebar
                // collapsed={true}
                toggled={this.state.toggled}
                breakPoint="md"
                onToggle={this.handleToggleSidebar}
              >
                <SidebarContent>
                  <Menu>
                    <MenuItem>
                      <div className="logo">
                        <Link to="/">
                          <img src={config.logo} alt="ThaiRun" />
                        </Link>
                      </div>
                      <AntMenu
                        style={{ width: 256 }}
                        // defaultSelectedKeys={[activedPathname]}
                        defaultSelectedKeys={['/']}
                        defaultOpenKeys={defaultOpenKeys}
                        selectedKeys={selectedKeys}
                        // defaultOpenKeys={[pathname[3]]}
                        // selectedKeys={[pathname[3]]}
                        mode={'inline'}
                        theme={'light'}
                        className=""
                        onClick={this.handleToggleClose}
                      >
                        {/* <AntMenu.Item key="Logo" className="menulogoitem">
                      
                    </AntMenu.Item> */}
                        <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['events'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          onClick={this.handleToggleClose} key="events">
                          <Link to="/">
                            <svg className="menuicon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.55 3.61923C16.55 4.71923 15.65 5.61923 14.55 5.61923C13.45 5.61923 12.55 4.71923 12.55 3.61923C12.55 2.51923 13.45 1.61923 14.55 1.61923C15.65 1.61923 16.55 2.51923 16.55 3.61923ZM11.95 15.1192L10.95 19.5192L3.95 18.1192L4.35 16.1192L9.25 17.1192L10.85 9.01923L9.05 9.71923V13.1192H7.05V8.41923L12.25 6.21923C12.4 6.21923 12.525 6.19423 12.65 6.16923C12.775 6.14423 12.9 6.11923 13.05 6.11923C13.75 6.11923 14.35 6.51923 14.75 7.11923L15.75 8.71923C16.55 10.1192 18.15 11.1192 20.05 11.1192V13.1192C17.85 13.1192 15.85 12.1192 14.55 10.6192L13.95 13.6192L16.05 15.6192V23.1192H14.05V17.1192L11.95 15.1192Z"
                                {...CheckIsActivePath({ paths: ['events'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Races
                            </span>
                          </Link>
                        </AntMenu.Item>
                        {eventId && <SubMenu
                          key="eventsSub"
                          title={
                            <span>
                              <Icon type="form" style={{ fontSize: 16 }} />
                              <span>Detail</span>
                            </span>
                          }
                        >
                          <AntMenu.Item key="stats">
                            <NavLink to={`/events/${eventId}/stats`}>
                              <Icon type="line-chart" style={{ fontSize: 16 }} />
                              {t('menu.registrationStat.title')}
                            </NavLink>
                          </AntMenu.Item>
                          {/* <AntMenu.Item key="stats-report">
                          <NavLink to={`/events/${eventId}/stats-report`}>
                            <Icon type="code" style={{fontSize: 16, color: '#FF0000'}} />
                              *Report
                          </NavLink>
                      </AntMenu.Item>         */}
                          <AntMenu.Item key="registrations">
                            <NavLink to={`/events/${eventId}/registrations`}>
                              <Icon type="team" style={{ fontSize: 16 }} />
                              {t('menu.registration.title')}
                            </NavLink>
                          </AntMenu.Item>
                          {/* <AntMenu.Item key="participants">
                          <NavLink to={`/events/${eventId}/participants`}>
                            <Icon type="user" style={{fontSize: 16}} />
                            Participants
                          </NavLink>
                        </AntMenu.Item> */}
                          {/* <AntMenu.Item key="tickets">
                          <NavLink to={`/events/${eventId}/tickets`}>
                            <Icon type="tag-o" style={{fontSize: 16}} />
                            Tickets
                          </NavLink>
                        </AntMenu.Item> */}
                          {!isLineLogin && <AntMenu.Item key="orders">
                            <NavLink to={`/events/${eventId}/orders`}>
                              <Icon type="shopping-cart" style={{ fontSize: 16 }} />
                              {t('menu.order.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          {!isLineLogin && <AntMenu.Item key="products">
                            <NavLink to={`/events/${eventId}/products`}>
                              <Icon type="barcode" style={{ fontSize: 16 }} />
                              {t('menu.product.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          {!isLineLogin && _includes(roles, 'organizer') && <AntMenu.Item key="edit:content">
                            <NavLink to={`/events/${eventId}/edit:content`}>
                              <Icon type="edit" style={{ fontSize: 16 }} />
                              {t('menu.product.editContent')}
                            </NavLink>
                          </AntMenu.Item>}
                          {/* {_includes(roles, 'admin') && <AntMenu.Item key="edit">
                        <NavLink to={`/events/${eventId}/edit`}>
                          <Icon type="form" style={{fontSize: 16}} />
                            แก้ไขงานวิ่ง
                        </NavLink>
                      </AntMenu.Item>} */}
                          {_includes(roles, 'admin') && <SubMenu
                            key="edit"
                            title={
                              <span>
                                <Icon type="form" style={{ fontSize: 16 }} />
                                <span>{t('menu.eventEdit.title')}</span>
                              </span>
                            }
                          >
                            <AntMenu.Item key="edit">
                              <NavLink to={`/events/${eventId}/edit`}>
                                <Icon type="schedule" style={{ fontSize: 16 }} />
                                {t('events.menu.general')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:shirts">
                              <NavLink to={`/events/${eventId}/edit:shirts`}>
                                <Icon type="skin" style={{ fontSize: 16 }} />
                                {t('events.menu.shirt')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:races">
                              <NavLink to={`/events/${eventId}/edit:races`}>
                                <Icon type="trophy" style={{ fontSize: 16 }} />
                                {t('events.menu.race')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:propertyquestions">
                              <NavLink to={`/events/${eventId}/edit:propertyquestions`}>
                                <Icon type="question" style={{ fontSize: 16 }} />
                                {t('events.menu.propertyQuestion')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:tickettypes">
                              <NavLink to={`/events/${eventId}/edit:tickettypes`}>
                                <Icon type="tags-o" style={{ fontSize: 16 }} />
                                {t('events.menu.ticket')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:registrationtypes">
                              <NavLink to={`/events/${eventId}/edit:registrationtypes`}>
                                <Icon type="form" style={{ fontSize: 16 }} />
                                {t('events.menu.registrantion')}
                              </NavLink>
                            </AntMenu.Item>
                            <AntMenu.Item key="edit:content">
                              <NavLink to={`/events/${eventId}/edit:content`}>
                                <Icon type="file-text" style={{ fontSize: 16 }} />
                                {t('events.menu.content')}
                              </NavLink>
                            </AntMenu.Item>
                          </SubMenu>}
                          {_includes(roles, 'admin') && <AntMenu.Item key="quick-books">
                            <NavLink to={`/events/${eventId}/quick-books`}>
                              <Icon type="rise" style={{ fontSize: 16 }} />
                              {isUnsetQb ?
                                <span style={{ color: 'red' }}>!!!QuickBook</span> :
                                `QuickBook`
                              }
                            </NavLink>
                          </AntMenu.Item>}
                          {(_includes(roles, 'admin') || _includes(_get(admin, 'abilities'), 'coupon')) && <AntMenu.Item key="coupon-code-types">
                            <NavLink to={`/events/${eventId}/coupon-code-types/list`}>
                              <Icon type="gift" style={{ fontSize: 16 }} />
                              {t('menu.couponcode.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          {/* <AntMenu.Item key="refund-requests">
                      <NavLink to={`/events/${eventId}/refund-requests`}>
                        <Icon type="swap" style={{fontSize: 16}} />
                          การคืนเงิน
                      </NavLink>
                    </AntMenu.Item> */}
                          {!isLineLogin && <AntMenu.Item key="cancel-requests">
                            <NavLink to={`/events/${eventId}/cancel-requests`}>
                              <Icon type="close-circle" style={{ fontSize: 16 }} />
                              {t('menu.refund.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          <AntMenu.Item key="runs">
                            <NavLink to={`/events/${eventId}/runs`}>
                              <Icon type="environment" style={{ fontSize: 16 }} />
                              {t('menu.virtualRun.title')}
                            </NavLink>
                          </AntMenu.Item>
                          {_includes(roles, 'admin') && <AntMenu.Item key="payment-summary">
                            <NavLink to={`/events/${eventId}/payment-summary`}>
                              <Icon type="bar-chart" style={{ fontSize: 16 }} />
                              {t('menu.payment.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          {_includes(roles, 'admin') && <AntMenu.Item key="withdraw-requests">
                            <NavLink to={`/events/${eventId}/withdraw-requests`}>
                              <Icon type="snippets" style={{ fontSize: 16 }} />
                              {t('menu.tranfer.title')}
                            </NavLink>
                          </AntMenu.Item>}
                          <AntMenu.Item key="downloads">
                            <NavLink to={`/events/${eventId}/downloads`}>
                              <Icon type="download" style={{ fontSize: 16 }} />
                              {t('menu.report.title')}
                            </NavLink>
                          </AntMenu.Item>
                        </SubMenu>}
                        {_includes(roles, 'admin') && <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['campaigns'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          onClick={this.handleToggleClose} key="campaigns">
                          <Link to="/campaigns">
                            <svg className="menuicon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM8 15H6V13H4V11H6V9H8V11H10V13H8V15ZM14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12ZM17 10.5C17 9.67157 17.6716 9 18.5 9C19.3284 9 20 9.67157 20 10.5C20 11.3284 19.3284 12 18.5 12C17.6716 12 17 11.3284 17 10.5Z"
                                {...CheckIsActivePath({ paths: ['campaigns'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Campaign
                            </span>
                          </Link>
                        </AntMenu.Item>}
                        {_includes(roles, 'admin') && <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['eventForms'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          onClick={this.handleToggleClose} key="eventForms">
                          <Link to="/eventForms">
                            <svg className="menuicon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM6 16H20V4H4V18L6 16Z"
                                {...CheckIsActivePath({ paths: ['eventForms'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Request
                            </span>
                          </Link>
                        </AntMenu.Item>}
                        {_includes(roles, 'admin') && <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['eventSummaryPayment'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          onClick={this.handleToggleClose} key="eventSummaryPayment">
                          <Link to="/eventSummaryPayment">
                            <svg className="menuicon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM6 16H20V4H4V18L6 16Z"
                                {...CheckIsActivePath({ paths: ['eventSummaryPayment'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Summary
                            </span>
                          </Link>
                        </AntMenu.Item>}
                        {_includes(roles, 'admin') && <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['StatisticsVR'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          onClick={this.handleToggleClose} key="StatisticsVR">
                          <Link to="/StatisticsVR">
                            <svg className="menuicon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM9 10H7V17H9V10ZM11 7H13V17H11V7ZM17 13H15V17H17V13Z"
                                {...CheckIsActivePath({ paths: ['StatisticsVR'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Report
                            </span>
                          </Link>
                        </AntMenu.Item>}
                        {_includes(roles, 'admin') && <AntMenu.Item
                          className={CheckIsActivePath({ paths: ['users', 'organizers', 'admins'] }).isActive === 'active' ? 'ant-menu-item-selected' : ''}
                          key="users">
                          <Link to="/users/organizers">
                            <svg className="menuicon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8ZM18 18C17.8 17.29 14.7 16 12 16C9.31 16 6.23 17.28 6 18H18ZM4 18C4 15.34 9.33 14 12 14C14.67 14 20 15.34 20 18V20H4V18Z"
                                {...CheckIsActivePath({ paths: ['users', 'organizers', 'admins'] }).activeMobileSvgProps}
                              />
                            </svg>
                            <span className="menutitle">
                              Users
                            </span>
                          </Link>
                        </AntMenu.Item>}
                      </AntMenu>
                    </MenuItem>
                  </Menu>
                </SidebarContent>
                <SidebarFooter>
                  <div className="menulogout">
                    <Popover placement="rightBottom" content={
                      <div>
                        <Button onClick={() => this.handleMenuClick({ key: 'logout' })}>
                          [{this.props.email}] ออกจากระบบ
                        </Button>
                      </div>
                    } trigger="click">
                      <Icon type="logout" />
                      <span className="menu-title">Logout</span>
                    </Popover>
                  </div>
                </SidebarFooter>
              </ProSidebar>
              <span className='menuTriggerIcon' onClick={this.handleToggleSidebar}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 8V6H21V8H3ZM3 13H21V11H3V13ZM3 18H21V16H3V18Z" fill="#F9A01B" />
                </svg>
              </span>
            </div>
          </MainMenu>

          {/* <Layout.Content style={{ background: '#fff', padding: 24, margin: 0, minHeight: 280 }}> */}

          <div className="maincontent">
            {/* <div>{t('title')}</div> */}
            <Suspense fallback={<div>Loading...</div>}>
              <Switch>
                <Route path="/events"
                  render={() => (
                    <Events handleToggleSidebar={this.handleToggleSidebar} />
                  )}
                />
                <Route path="/fetchPage" component={FetchPage} />
                <Route path="/StatisticsVR" component={StatisticsVR} />
                <Route path="/MedalClaims" component={MedalClaims} />

                {_includes(roles, 'admin') && <Route path="/reports" component={Reports} />}
                {_includes(roles, 'admin') && <Route path="/users/organizers" component={Organizers} />}
                {_includes(roles, 'admin') && <Route path="/users/admins" component={Admins} />}
                {_includes(roles, 'admin') && <Route path="/users/list" component={UserList} />}
                {_includes(roles, 'admin') && <Route path="/users/tranfer" component={UserTranfer} />}
                {_includes(roles, 'admin') && <Route path="/eventForms" component={EventForms} />}
                {_includes(roles, 'admin') && <Route path="/eventSummaryPayment" component={EventSummaryPayment} />}
                {_includes(roles, 'admin') && <Route path="/financialDailyBalance" component={FinancialDailyBalance} />}
                {_includes(roles, 'admin') && <Route path="/campaigns" component={Campaigns} />}
                {_includes(roles, 'admin') && <Route path="/histories" component={Histories} />}
                {/* { (_includes(roles, 'admin') || _includes(roles, 'accountant')) && <Route path="/withdraw" component={Withdraw} /> } */}
                {/* { _includes(roles, 'admin') && <Route path="/campaigns" exact component={Campaigns} /> }
                { _includes(roles, 'admin') && <Route path="/campaigns/create" exact component={CampaignEdit} /> } */}
                <Route path="/" render={() => <Redirect to='/events' />} />
                {/* <Route path="/" component={Dashboard} /> */}
              </Switch>
            </Suspense>
          </div>
        </div>
      </AppWrapper>
    )
  }
}

export default compose(
  withApollo,
  withTranslation()
)(App)
